import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';

function Input({clearSearch, search}) {
  return (
    <TextField
      autoComplete='off'
      variant='filled'
      label='Filtrar'
      fullWidth
      InputProps={{
        shrink: true,
        endAdornment: <InputAdornment position='end'>
          <IconButton aria-label='clear-search' onClick={clearSearch}>
            <Clear color='action'/>
          </IconButton>
        </InputAdornment>
      }}
      {...search}
    />
  );
}

Input.propTypes = {
  value: PropTypes.string,
  required: PropTypes.bool
};

export default Input;
